// extracted by mini-css-extract-plugin
export var closeButton = "_gz-1";
export var closeX = "_gz-3";
export var container = "_gz-0";
export var image = "_gz-2";